const table = document.querySelector('.datatable')

export default {
  can: () => table,
  run: () => {
    const table = document.querySelector('.datatable')

    new DataTable(table, {
      pageLength: 12,
      responsive: {
        details: {
          type: 'column',
          target: 'tr',
        },
      },
      columnDefs: [
        {
          className: 'control',
          orderable: false,
          targets: 0,
        },
      ],
      order: [1, 'asc'],
    })
  },
}
